let initialState = {
    assetsLoaded: false
};

let assets = []

function AssetsLoadedReducer(state = initialState, action){
    switch (action.type) {

        case "NEW_ASSET":
            assets.push(action.payload)
            return state;

        case "ASSET_LOADED":
            assets = assets.filter(e => e !== action.payload);
            // console.log(assets); //find which assets arent loading
            return {
                assetsLoaded: assets.length === 0
            };

        default:
            return state;
    }
}

export default AssetsLoadedReducer;
